var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#00A88E;stroke-miterlimit:10;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#00AF9A;}\n\t.st2{fill:#00AF9A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.5,8C32,8,8.9,31.1,8.9,59.5c0,13.1,4.9,25,12.9,34c1.2,1.3,2.4,2.6,3.7,3.7c0.1,0.1,0.1,0.1,0.2,0.2 c1.2,1.1,2.5,2.2,3.8,3.1c0.2,0.1,0.3,0.2,0.5,0.4c1.2,0.9,2.5,1.7,3.8,2.5c0.3,0.2,0.5,0.3,0.8,0.5c1.2,0.7,2.5,1.4,3.7,2 c0.4,0.2,0.7,0.4,1.1,0.5c1.2,0.5,2.4,1,3.7,1.5c0.5,0.2,0.9,0.3,1.4,0.5c1.2,0.4,2.4,0.7,3.7,1c0.5,0.1,1,0.3,1.6,0.4 c1.3,0.3,2.6,0.5,3.8,0.6c0.5,0.1,1,0.2,1.5,0.2c1.8,0.2,3.6,0.3,5.5,0.3s3.7-0.1,5.5-0.3c0.5-0.1,1-0.2,1.5-0.2 c1.3-0.2,2.6-0.4,3.9-0.6c0.5-0.1,1-0.3,1.5-0.4c1.3-0.3,2.5-0.6,3.7-1c0.4-0.1,0.8-0.3,1.3-0.5c1.3-0.5,2.5-0.9,3.8-1.5 c0.3-0.1,0.6-0.3,1-0.5c1.3-0.6,2.6-1.3,3.9-2c0.2-0.1,0.4-0.3,0.6-0.4c1.3-0.8,2.6-1.7,3.9-2.6c0.1-0.1,0.2-0.2,0.4-0.3 c1.3-1,2.6-2,3.8-3.2l0.1-0.1c1.3-1.2,2.5-2.4,3.7-3.7C107,84.7,112,72.7,112,59.5C112,31.1,88.9,8,60.5,8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.6,31c5.1,0,9.2,4.1,9.2,9.2s-4.1,9.2-9.2,9.2s-9.2-4.1-9.2-9.2S40.5,31,45.6,31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.3,49.4c-5.1,0-9.2-4.1-9.2-9.2s4.1-9.2,9.2-9.2s9.2,4.1,9.2,9.2S80.4,49.4,75.3,49.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.7,84.8c1.1,1,1.2,2.7,0.2,3.8s-2.7,1.2-3.8,0.2c-24.5-22.7-48.3-1.2-49.3-0.3l0,0c-1.1,1-2.8,1-3.8-0.1 c-1-1.1-1-2.8,0.1-3.8c0.2-0.2,12.6-11.5,29.2-11.5C69.7,73.1,79.2,76.1,88.7,84.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.12fc1559.svg";
export { ForwardRef as ReactComponent };